import { useDispatch } from "react-redux";
import { Button } from "primereact/button";
import { useLocation, useNavigate } from "react-router-dom";
import { signIn, signOut } from "../../Features/Auth/AuthenticationSlice";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../Features/config/firebase";
import moonbugLogo from "./moonbuglogo.png";
import { useEffect, useRef, useState } from "react";
import {
  GoogleAuthProvider,
  browserLocalPersistence,
  setPersistence,
  signInWithPopup,
} from "firebase/auth";
import { Card } from "primereact/card";
import { ROUTES } from "../../config/routes";
import { consumeStashedPostLoginRedirect } from "../../utils/authRedirect";
import { apiService } from "../../api/api";
import { trackToolAction } from "../../utils/analytics";

//TODO: add storing user credentials in Firestore
const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [currentUser] = useAuthState(auth);
  const provider = new GoogleAuthProvider();
  const loginHandledRef = useRef(false);
  const [loginError, setLoginError] = useState<string | null>(null);

  const signInWithGoogle = async () => {
    setLoginError(null);
    try {
      await setPersistence(auth, browserLocalPersistence);
      await signInWithPopup(auth, provider);
    } catch (error) {
      console.error("Error signing in with Google:", error);
    }
  };

  useEffect(() => {
    if (!currentUser) {
      loginHandledRef.current = false;
      return;
    }
    if (loginHandledRef.current) return;

    loginHandledRef.current = true;

    void (async () => {
      try {
        let idTokenResult = await currentUser.getIdTokenResult();
        const role = idTokenResult.claims.role;

        if (role !== "admin" && role !== "user") {
          await apiService.users.initializeClaims(currentUser.email!);
          await currentUser.getIdToken(true);
          idTokenResult = await currentUser.getIdTokenResult(true);
        }

        const fromState = (location.state as { from?: { pathname?: string; search?: string } })
          ?.from;
        const stashed = consumeStashedPostLoginRedirect();
        const nextPath =
          fromState?.pathname || stashed?.pathname || ROUTES.HOMEPAGE;
        const nextSearch = fromState?.search ?? stashed?.search ?? "";
        const nextTarget = `${nextPath}${nextSearch}`;

        dispatch(
          signIn({
            displayName: currentUser.displayName,
            email: currentUser.email,
            photoURL: currentUser.photoURL,
            uid: currentUser.uid,
            roles: idTokenResult.claims,
          })
        );
        trackToolAction("Login", "login_success");
        navigate(nextTarget);
      } catch (error) {
        console.error("Login bootstrap failed:", error);
        loginHandledRef.current = false;
        setLoginError(
          "Your account is not provisioned. Contact an administrator."
        );
        await auth.signOut();
        dispatch(signOut());
      }
    })();
  }, [currentUser, dispatch, location.state, navigate]);

  return (
    <div style={{ backgroundColor: "rgb(0,0,0,0.007" }}>
      <div
        style={{
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Card
          style={{
            boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
            backgroundColor: "rgb(248 248 250)",
            height: "500px",
            width: "400px",
          }}
          header={
            <img
              alt="logo"
              src={moonbugLogo}
              className="card flex justify-content-center"
              style={{
                width: "240px",
                height: "100px",
                marginLeft: "auto",
                marginRight: "auto",
                marginTop: "40px",
                marginBottom: "0px",
              }}
            ></img>
          }
          footer={
            <div
              style={{
                marginBottom: "100px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                height: "100%",
              }}
            >
              <span>
                <h1
                className="app-menubar-title"
                  style={{
                    height: "60px",
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: "60px",
                    color: "rgba(0, 0, 0, 0.5)",
                    fontSize: "30px",
                    fontWeight: "bold",
                  }}
                >
                  Sign in:
                </h1>
              </span>
              {loginError && (
                <p
                  style={{
                    color: "#c0392b",
                    fontSize: "14px",
                    margin: "0 24px 8px",
                  }}
                >
                  {loginError}
                </p>
              )}
              <Button
                onClick={signInWithGoogle}
                rounded
                className="p-button-primary"
                style={{
                  backgroundColor: "#1A0BD9",
                  color: "#fff",
                  borderRadius: "5px",
                  padding: "10px 10px",
                  marginLeft: "auto",
                  marginRight: "auto",
                  marginTop: "20px",
                  height: "100px",
                  width: "200px",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <span
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                  }}
                >
                  Continue with Google
                </span>
              </Button>
            </div>
          }
        ></Card>
      </div>
    </div>
  );
};

export default Login;
